<script setup lang="ts">
import { useGameStore } from '@/stores/gameStore.ts'
import { computed } from 'vue'
import { useAssetStore } from '@/stores/assetStore.ts'
import MediumModel from '@/components/Interface/Modal/ModelSizes/MediumModel.vue'
import { CDN } from '@/models/cdn.ts'

// Get the planet data
const gameStore = useGameStore()
const assetStore = useAssetStore()

const ore = computed(() => {
  return assetStore.findOreById(gameStore.modalData.oreId)
})
</script>

<template>
  <MediumModel :title="ore.oreName">
    <div class="flex flex-col sm:flex-row text-center sm:text-left">
      <img
        class="m-2 self-center sm:self-start w-auto md:w-1/3"
        :src="CDN.ore(ore.id, 256)"
        alt=""
      />
      <div class="text-subtext p-2">
        <div>{{ ore.description }}</div>
        <div class="pt-2 grid grid-cols-2 gap-1"></div>
      </div>
    </div>
  </MediumModel>
</template>

<style scoped lang="scss"></style>
